import request from '@/router/axios'

export function fetchList(query) {
  return request({
    url: '/codegen/generator/page',
    method: 'get',
    params: query
  })
}

export function handleDownload(table) {
  return request({
    url: '/codegen/generator/code',
    method: 'post',
    data: table
    ,responseType: 'blob'
  }).then((response) => { // 处理返回的文件流
    //const blob = new Blob([response.data], { type: 'application/zip' })
    /*const url = window.URL.createObjectURL(response.data)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', table.tableName + '.zip')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)*/
    //let disposition = response.headers['content-disposition']
    //console.log(disposition.match(/filename="(.*)"/))
    //let filename = decodeURI(disposition.match(/filename="(.*)"/))
    var fileDownload = require('js-file-download');
    let filename = table.tableName+'.zip'
    fileDownload(response.data, filename)

  })
}

